if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

/* ==========================================================
   NZM delivery note + Click & Collect box under Add to cart (Oct 2026)
   Delivery wording mirrors /pages/delivery-return. Edit CUTOFF / text here.
   Delivery note not shown on equipment templates or bulky product types.
   Click & Collect is styled to match the delivery note on all product pages,
   and added to the NZ Muscle Supps (mnBuyRow) template, which has no buy_buttons block.
   ========================================================== */
(function () {
  var CUTOFF_HOUR = 15; // 3pm NZ time, Mon-Fri
  var DEFAULT_LINE = 'Auckland overnight · Rest of NZ 1–2 business days';
  var SUB_LINE = 'Free NZ shipping on orders over $70*';
  var SCRIPT_SRC = (document.currentScript && document.currentScript.src) || '';
  var ASSET_BASE = SCRIPT_SRC.replace(/product-form\.js.*$/, '');
  var STORE_ICON = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2300b8f0' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M3 9l1.5-5h15L21 9'/%3E%3Cpath d='M3 9h18'/%3E%3Cpath d='M4.5 9v11h15V9'/%3E%3Cpath d='M9.5 20v-6h5v6'/%3E%3C/svg%3E\")";

  function nzNow() {
    try {
      var p = new Intl.DateTimeFormat('en-NZ', { timeZone: 'Pacific/Auckland', weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false }).formatToParts(new Date());
      var o = {};
      p.forEach(function (x) { o[x.type] = x.value; });
      return { day: o.weekday, h: parseInt(o.hour, 10) % 24, m: parseInt(o.minute, 10) };
    } catch (e) { return null; }
  }

  function render(el) {
    var main = el.querySelector('.nzm-dn__main');
    var n = nzNow();
    if (!n) return;
    var weekday = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].indexOf(n.day) !== -1;
    var mins = CUTOFF_HOUR * 60 - (n.h * 60 + n.m);
    if (weekday && mins > 0) {
      var h = Math.floor(mins / 60), m = mins % 60;
      main.innerHTML = 'Order within <span class="nzm-dn__time">' + (h ? h + 'h ' : '') + m + 'm</span> for overnight delivery';
    } else {
      main.textContent = DEFAULT_LINE;
    }
  }

  function injectCss() {
    if (document.getElementById('nzm-dn-css')) return;
    var st = document.createElement('style');
    st.id = 'nzm-dn-css';
    st.textContent = '.nzm-dn{display:flex;align-items:flex-start;gap:10px;margin:12px 0 4px;padding:10px 12px;border-radius:10px;background:#f2f7fa;color:#0d0d0d;font-size:13px;line-height:1.4}' +
      '.nzm-dn__icon{width:20px;height:20px;flex:none;margin-top:1px;color:#00b8f0}' +
      '.nzm-dn__txt{display:flex;flex-direction:column;gap:2px}.nzm-dn__main{font-weight:700}.nzm-dn__sub{color:#5f5f5f}.nzm-dn__time{color:#0a8f4d}' +
      /* Click & Collect box - matches the delivery note */
      'pickup-availability[available]{min-height:0}' +
      'pickup-availability>.pickup-availability-preview{display:flex;align-items:flex-start;gap:10px;margin:-17px 0 4px;padding:10px 12px;border-radius:10px;background:#f2f7fa;color:#0d0d0d;font-size:13px;line-height:1.4}' +
      'pickup-availability.nzm-pk-host{margin:0 !important}' +
      'pickup-availability.nzm-pk-host>.pickup-availability-preview{margin-top:-3px}' +
      'pickup-availability>.pickup-availability-preview::before{content:"";width:20px;height:20px;flex:none;margin-top:1px;background:' + STORE_ICON + ' center/contain no-repeat}' +
      'pickup-availability>.pickup-availability-preview:not(:has(.svg-wrapper))::before{opacity:.45}' +
      'pickup-availability>.pickup-availability-preview>.svg-wrapper{display:none}' +
      'pickup-availability .pickup-availability-info{display:flex;flex-direction:column;align-items:flex-start;gap:2px;min-width:0}' +
      'pickup-availability .pickup-availability-info>*{margin:0}' +
      'pickup-availability .pickup-availability-info .caption-large{font-size:13px;line-height:1.4;letter-spacing:normal;font-weight:700;color:#0d0d0d}' +
      'pickup-availability .pickup-availability-info .caption-large,pickup-availability .pickup-availability-info .caption-large *{font-family:inherit}' +
      'pickup-availability .pickup-availability-info .caption{font-size:13px;line-height:1.4;letter-spacing:normal;color:#5f5f5f}' +
      'pickup-availability .pickup-availability-button{font-size:12px;line-height:1.4;letter-spacing:normal;color:#0d0d0d;padding:0;margin-top:2px;text-underline-offset:2px}' +
      'pickup-availability .pickup-availability-button:hover{color:#00b8f0}';
    document.head.appendChild(st);
  }

  function loadPickupAssets() {
    if (!ASSET_BASE) return;
    if (!document.querySelector('link[href*="component-pickup-availability.css"]')) {
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = ASSET_BASE + 'component-pickup-availability.css';
      document.head.appendChild(l);
    }
    if (!customElements.get('pickup-availability') && !document.querySelector('script[src*="pickup-availability.js"]')) {
      var s = document.createElement('script');
      s.src = ASSET_BASE + 'pickup-availability.js';
      s.defer = true;
      document.head.appendChild(s);
    }
  }

  function addPickup(main, after) {
    if (main.querySelector('pickup-availability')) return;
    var idInput = main.querySelector('.mnProductForm [name="id"]') || main.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!idInput || !idInput.value) return;

    var wrap = document.createElement('div');
    wrap.innerHTML = '<pickup-availability class="product__pickup-availabilities nzm-pk-host" available data-root-url="' + ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + '" data-variant-id="' + idInput.value + '" data-product-page-color-scheme="gradient color-scheme-1">' +
      '<template><pickup-availability-preview class="pickup-availability-preview"><div class="pickup-availability-info"><p class="caption-large">Couldn\'t load Click &amp; Collect availability</p><button class="pickup-availability-button link link--text underlined-link">Refresh</button></div></pickup-availability-preview></template>' +
      '</pickup-availability>';
    var pk = wrap.firstElementChild;
    after.insertAdjacentElement('afterend', pk);
    loadPickupAssets();

    document.addEventListener('variant:change', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v || !pk.isConnected) return;
      pk.dataset.variantId = v.id;
      if (typeof pk.update === 'function') pk.update(v);
    });
  }

  function init() {
    var cls = document.body.className;
    if (!/\btemplate-product/.test(cls)) return;
    injectCss();

    var main = document.getElementById('MainContent');
    if (!main) return;
    var buyRow = main.querySelector('.mnBuyRow');
    var anchor = buyRow || main.querySelector('product-form .product-form__buttons');
    if (!anchor) return;

    var showNote = true;
    if (/template-product-(force-usa|livepro-liveup|centr-hyrox)/.test(cls)) showNote = false;
    var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    if (meta && /equipment|bench|rack|treadmill|rower|bike|machine|dumbbell set|plate/i.test(meta.type || '')) showNote = false;

    var note = main.querySelector('.nzm-dn');
    if (showNote && !note) {
      note = document.createElement('div');
      note.className = 'nzm-dn';
      note.innerHTML = '<svg class="nzm-dn__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17.5" cy="17.5" r="1.6"/></svg>' +
        '<div class="nzm-dn__txt"><strong class="nzm-dn__main"></strong><span class="nzm-dn__sub">' + SUB_LINE + '</span></div>';
      anchor.insertAdjacentElement('afterend', note);
      render(note);
      setInterval(function () { render(note); }, 60000);
    }

    // NZ Muscle Supps template: buy row has no built-in Click & Collect - add it under the delivery note
    if (buyRow) addPickup(main, note || buyRow);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
